<ng-container *transloco="let t">
  <div class="documentsUploadBox">
    <p-fileUpload
      name="uploadPolicyDocs"
      accept=".pdf, .jpg, .jpeg, .jfif, .pjpeg, .pjp, .gif, .bmp, .png, .webp, .apng, .svg"
      [auto]="true"
      [chooseLabel]="t('documentsUpload.documentBox.uploadBtn')"
      [chooseStyleClass]="isWarranty ? 'p-fileupload-choose--green' : ''"
      maxFileSize="10000000"
      chooseIcon=""
      customUpload="true"
      (uploadHandler)="handleUpload($event)">
      <ng-template pTemplate="toolbar"> </ng-template>

      <ng-template
        let-file
        pTemplate="file">
      </ng-template>

      <ng-template
        pTemplate="content"
        let-files>
        <div class="documentsUploadBox__content">
          <div class="documentsUploadBox__content__image">
            <img
              [src]="documentBox.documentBoxImg"
              alt="upload image" />
            <img
              class="documentsUploadBox__content__image__check"
              *ngIf="documentBox.uploaded"
              src="../../../../assets/icons/check-icon.svg"
              alt="image uploaded" />
          </div>
          <p class="documentsUploadBox__content__title">
            {{ t(documentBox.documentBoxTitle) }}
          </p>
          <div
            class="documentsUploadBox__content__documents"
            *ngIf="documentBox.documents">
            <ng-container *ngFor="let document of documentBox.documents">
              <div class="documentsUploadBox__content__documents__document">
                <div class="document__info">{{ document.filename }}</div>
                <div
                  class="document__deleteBtn"
                  (click)="deleteDocument(document)">
                  <img
                    src="../../../../assets/icons/cross.svg"
                    alt="cross icon" />
                </div>
              </div>
            </ng-container>
          </div>
          <div
            *ngIf="!documentBox.documents"
            class="documentsUploadBox__content__description">
            {{ t('documentsUpload.documentBox.invoice.description') }}
          </div>
        </div>
      </ng-template>
    </p-fileUpload>
  </div>
</ng-container>
